import { render, staticRenderFns } from "./listar-tipo-deficiencia.vue?vue&type=template&id=0a4cd6a7&"
import script from "./listar-tipo-deficiencia.vue?vue&type=script&lang=ts&"
export * from "./listar-tipo-deficiencia.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins-hml/workspace/pracessivel-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a4cd6a7')) {
      api.createRecord('0a4cd6a7', component.options)
    } else {
      api.reload('0a4cd6a7', component.options)
    }
    module.hot.accept("./listar-tipo-deficiencia.vue?vue&type=template&id=0a4cd6a7&", function () {
      api.rerender('0a4cd6a7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/tipo-deficiencia/listar-tipo-deficiencia.vue"
export default component.exports